<template>
  <div class="app-breadcrumb-wrap mt-5" style="margin-top: 10px;">
    <div class="app-breadcrumb-left">
      <a-breadcrumb class="app-breadcrumb">
        
        <a-breadcrumb-item>
          <router-link to="/" class="crumb-home">
            <span class="crumb-icon">🏠</span>
            <span>Bosh sahifa</span>
          </router-link>
        </a-breadcrumb-item>

        <a-breadcrumb-item v-for="(item, index) in items" :key="index">
          <template v-if="item.to">
            <router-link :to="item.to" class="crumb-link">
              {{ item.label }}
            </router-link>
          </template>

          <template v-else-if="item.click">
            <button class="crumb-link crumb-action-btn" @click="item.click">
              {{ item.label }}
            </button>
          </template>

          <template v-else>
            <span class="crumb-current">
              {{ item.label }}
            </span>
          </template>
        </a-breadcrumb-item>
      </a-breadcrumb>
    </div>

    <div v-if="$slots.actions" class="app-breadcrumb-actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    showBack: {
      type: Boolean,
      default: false
    }
  },
  emits: ['back']
}
</script>

<style scoped>
.app-breadcrumb-wrap {
  margin-bottom: 14px;
  padding: 10px 14px;
  border: 1px solid var(--border);
  border-radius: 14px;
  background: linear-gradient(180deg, rgba(255,255,255,0.03), rgba(255,255,255,0.01));
  box-shadow: var(--shadow);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.app-breadcrumb-left {
  min-width: 0;
  overflow-x: auto;
}

.app-breadcrumb {
  white-space: nowrap;
}

.app-breadcrumb-actions {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.crumb-home,
.crumb-link,
.crumb-current,
.crumb-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 28px;
  padding: 4px 10px;
  border-radius: 10px;
  font-size: 13px;
  transition: 0.2s ease;
}

.crumb-home,
.crumb-link {
  color: var(--text-soft);
  background: rgba(255, 255, 255, 0.02);
}

.crumb-home:hover,
.crumb-link:hover {
  color: var(--text);
  background: rgba(59, 130, 246, 0.10);
}

.crumb-current {
  color: var(--text);
  font-weight: 700;
  background: rgba(59, 130, 246, 0.14);
  border: 1px solid rgba(59, 130, 246, 0.18);
}

.crumb-back-btn {
  border: 1px solid var(--border);
  background: rgba(255,255,255,0.02);
  color: var(--text);
  cursor: pointer;
}

.crumb-back-btn:hover {
  background: rgba(59, 130, 246, 0.10);
}

.crumb-action-btn {
  border: none;
  outline: none;
  cursor: pointer;
  font-family: inherit;
}

.crumb-icon {
  font-size: 13px;
  line-height: 1;
}

:deep(.ant-breadcrumb) {
  color: var(--text-soft);
  font-size: 13px;
}

:deep(.ant-breadcrumb a) {
  color: inherit;
}

:deep(.ant-breadcrumb-separator) {
  color: var(--text-soft) !important;
  margin-inline: 6px !important;
}

@media (max-width: 768px) {
  .app-breadcrumb-wrap {
    padding: 8px 10px;
    border-radius: 12px;
    align-items: flex-start;
    flex-direction: column;
  }

  .app-breadcrumb-actions {
    width: 100%;
    justify-content: flex-end;
  }

  .crumb-home,
  .crumb-link,
  .crumb-current,
  .crumb-back-btn {
    font-size: 12px;
    padding: 4px 8px;
  }
}
</style>